// extracted by mini-css-extract-plugin
export default {"actionContainer":"actionContainer-zCeea","bigMessage":"bigMessage-l2uCs"};